import React, { ReactNode, useRef, useState } from 'react';
import debounce from 'lodash/debounce';
import { matchSorter } from 'match-sorter';
import TextField from '@/components/form/TextField/TextField';
import { FilterContainer, FilterResult } from './FilterListItems.styles';
import { useTranslations } from 'next-intl';

export interface FilterListItemsProps<T> {
  initialData: T[];
  counter?: number;
  placeholder: string;
  children: ReactNode | (({ data }: { data: T[] }) => ReactNode);
  handleFilter?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleReset?: () => void;
}

// function FilterListItems<T>({ initialData, keys, placeholder, children, ...props }: FilterListItemsProps<T>) {
// https://react-typescript-cheatsheet.netlify.app/docs/advanced/patterns_by_usecase#generic-components
const FilterListItems = <T,>({
  initialData,
  placeholder,
  handleFilter,
  handleReset,
  counter: counterProp,
  children,
}: FilterListItemsProps<T>) => {
  const t = useTranslations('Viagem');
  const inputRef = useRef<HTMLInputElement>(null);
  const [data, setData] = useState<T[]>(initialData);

  const _handleFilter = (event: React.ChangeEvent<HTMLInputElement>): void => {
    event.preventDefault();
    if (typeof handleFilter === 'function') {
      handleFilter(event);
    } else {
      const value = event.target.value;

      if (value.length === 0) {
        setData((prevState) => [...initialData]);
      } else {
        debounce(() => {
          const results: any = matchSorter(initialData, value, { keys: ['title'] });
          setData((prevState) => results);
        }, 200)();
      }
    }
  };

  const _handleReset = (): void => {
    if (inputRef.current?.value) {
      inputRef.current.value = '';
      if (typeof handleReset === 'function') {
        handleReset();
      } else {
        setData(() => initialData);
      }
    }
  };

  let counter;
  if (typeof counterProp !== 'undefined') {
    counter = counterProp;
  } else {
    counter = data.length;
  }

  return (
    <>
      <FilterContainer>
        <form onSubmit={(e) => e.preventDefault()}>
          <TextField
            ref={inputRef}
            type="text"
            placeholder={placeholder}
            name="filter"
            onChange={_handleFilter}
            bgIcon="search"
          />
        </form>
      </FilterContainer>
      <FilterResult fade={!!inputRef.current?.value}>
        <span>
          <strong>{counter}</strong> ite{counter > 1 ? t('ns') : `m`} {t('encontrado(s)')}
        </span>
        <span>
          <button onClick={_handleReset}>{t('limpar filtro')}</button>
        </span>
      </FilterResult>
      {(typeof children === 'function' && children({ data })) || children}
    </>
  );
};

export default FilterListItems;
